class TatvamasiGiftWrap {

    constructor() {

        /* ==========================================
           ELEMENTS
        ========================================== */

        this.checkbox =
            document.getElementById("gift-wrap-checkbox");

        this.wrapper =
            document.getElementById("gift-message-wrapper");

        this.message =
            document.getElementById("gift-message");

        this.counter =
            document.getElementById("gift-count");

        this.rudrakshCheckbox =
            document.getElementById("rudraksh-checkbox");

        this.rudrakshWrapper =
            document.getElementById("rudraksh-info-wrapper");

        this.handSizeCheckboxes =
            document.querySelectorAll(
                '.hand-size-checkbox input[type="checkbox"]'
            );


        /* ==========================================
           PRODUCT FORM
        ========================================== */

        this.productForm =
            document.querySelector(
                'form[data-type="add-to-cart-form"]'
            );


        this.init();

    }


    init() {

        if (
            !this.checkbox &&
            !this.rudrakshCheckbox &&
            !this.handSizeCheckboxes.length
        ) {
            return;
        }


        /* ==========================================
           CONNECT OPTIONS TO PRODUCT FORM
        ========================================== */

        this.connectToProductForm();


        /* ==========================================
           GIFT WRAPPING
        ========================================== */

        if (this.checkbox) {

            this.checkbox.addEventListener(
                "change",
                () => {

                    if (this.wrapper) {

                        this.wrapper.classList.toggle(
                            "show",
                            this.checkbox.checked
                        );

                    }

                }
            );

        }


        /* ==========================================
           GIFT MESSAGE CHARACTER COUNTER
        ========================================== */

        if (
            this.message &&
            this.counter
        ) {

            this.message.addEventListener(
                "input",
                () => {

                    this.counter.textContent =
                        250 -
                        this.message.value.length;

                }
            );

        }


        /* ==========================================
           5 MUKHI RUDRAKSH
        ========================================== */

        if (
            this.rudrakshCheckbox &&
            this.rudrakshWrapper
        ) {

            this.rudrakshCheckbox.addEventListener(
                "change",
                () => {

                    this.rudrakshWrapper.classList.toggle(
                        "show",
                        this.rudrakshCheckbox.checked
                    );

                }
            );

        }

        /* ==========================================
   HAND SIZE
========================================== */

    if (this.handSizeCheckboxes.length) {

        this.handSizeCheckboxes.forEach(
            (checkbox) => {

                checkbox.addEventListener(
                    "change",
                    () => {

                        if (checkbox.checked) {

                            this.handSizeCheckboxes.forEach(
                                (otherCheckbox) => {

                                    if (
                                        otherCheckbox !== checkbox
                                    ) {

                                        otherCheckbox.checked = false;

                                    }

                                }
                            );

                        }

                    }
                );

            }
        );

    }

    }


    /* ==========================================
       CONNECT OUTSIDE ELEMENTS TO PRODUCT FORM
    ========================================== */

    connectToProductForm() {

        if (!this.productForm) {

            console.error(
                "Tatvamasi: Product form not found."
            );

            return;

        }


        const formId =
            this.productForm.id;


        if (!formId) {

            console.error(
                "Tatvamasi: Product form has no ID."
            );

            return;

        }


        /*
         * Connect Gift Wrap checkbox
         */

        if (this.checkbox) {

            this.checkbox.setAttribute(
                "form",
                formId
            );

        }


        /*
         * Connect Gift Message
         */

        if (this.message) {

            this.message.setAttribute(
                "form",
                formId
            );

        }


        /*
         * Connect Rudraksha checkbox
         */

        if (this.rudrakshCheckbox) {

            this.rudrakshCheckbox.setAttribute(
                "form",
                formId
            );

        }


        if (this.handSizeCheckboxes.length) {

            this.handSizeCheckboxes.forEach(
                (checkbox) => {

                    checkbox.setAttribute(
                        "form",
                        formId
                    );

                }
            );

        }


        console.log(
            "Tatvamasi: Gift options connected to product form:",
            formId
        );

    }

}


/* ==========================================
   INITIALIZE
========================================== */

document.addEventListener(
    "DOMContentLoaded",
    () => {

        new TatvamasiGiftWrap();

    }
);